import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactForm from '../components/contactForm/ContactForm'

const localBizSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'IPB Finland',
  url: 'https://jetpeel.fi',
  telephone: '+358 45 229 1929',
  email: 'infinite@ipb.fi',
  image: 'https://jetpeel.fi/img/og-image.jpg',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Kauppiaankatu 2',
    addressLocality: 'Helsinki',
    addressCountry: 'FI',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'Customer Service',
    availableLanguage: ['Finnish', 'English', 'Russian'],
  },
};

const Contacts = () => {
  const { t } = useTranslation();
  return (
    <main>
      <Helmet>
        <title>{t("contact_form.title")} | JetPeel</title>
        <meta name="description" content={t("contact_form.subtitle")} />
        <meta name="keywords" content="JetPeel, yhteystiedot, yhteydenotto, esteettinen hoito, IPB Finland" />
        <link rel="canonical" href="https://jetpeel.fi/contacts" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`${t("contact_form.title")} | JetPeel`} />
        <meta property="og:description" content={t("contact_form.subtitle")} />
        <meta property="og:url" content="https://jetpeel.fi/contacts" />
        <meta property="og:image" content="https://jetpeel.fi/img/og-image.jpg" />
        <script type="application/ld+json">{JSON.stringify(localBizSchema)}</script>
      </Helmet>
      <section className="form__frame section">
        <div className="container">
          <div className="form__wrapper">
            <div className="form__image">

            </div>
            <ContactForm />
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contacts;
